import { useEffect, useState } from 'react'
import { DashboardGroup } from 'experiences/dashboard/DashboardRoot'
import { buildDefaultDashItem } from 'experiences/dashboard/DashboardRoot/cards'
import { getDashboardSearchesGroup } from 'experiences/dashboard/DashboardRoot/lib/searchItems'
import { ID } from 'lib'

export const useSearchGroup = () => {
	const [state, setState] = useState<DashboardGroup>({
		key: ID('search'),
		items: [buildDefaultDashItem(), buildDefaultDashItem()]
	})
	useEffect(() => {
		setState(getDashboardSearchesGroup())
	}, [])
	return state
}
